import React, { Component } from "react";

class Footer extends Component {
  render() {
    const info = this.props.sharedBasicInfo;

    return (
      <footer>
        <div className="footer-inner">
          <div className="footer-logo">
            JF<em>.</em>
          </div>
          <nav className="footer-nav">
            {info &&
              info.social.map((s) => (
                <a
                  key={s.name}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {s.name}
                </a>
              ))}
          </nav>
          <p className="footer-copy">
            © {new Date().getFullYear()}{" "}
            {info ? info.name : "Jared Flores"} — Game Developer &amp;
            Front-End Developer
          </p>
        </div>
      </footer>
    );
  }
}

export default Footer;
